function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.517 18.09a6.462 6.462 0 0 1-6.455-6.454A6.462 6.462 0 0 1 8.517 5.18a6.462 6.462 0 0 1 6.455 6.455 6.462 6.462 0 0 1-6.455 6.455M18.44.863l-3.95.194a.52.52 0 0 0-.495.519h0c0 .3.253.537.552.518l2.63-.163-3.904 3.903a7.445 7.445 0 0 0-4.756-1.7c-2.004 0-3.888.78-5.304 2.197a7.453 7.453 0 0 0-2.198 5.305c0 2.004.78 3.888 2.198 5.304a7.453 7.453 0 0 0 5.304 2.198c2.004 0 3.888-.78 5.305-2.198a7.453 7.453 0 0 0 2.197-5.304 7.448 7.448 0 0 0-1.985-5.083l3.882-3.882-.163 2.63a.52.52 0 1 0 1.037.057l.194-3.951a.52.52 0 0 0-.544-.544",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.7,
  fillRule: "evenodd"
});

var SvgMale = function SvgMale(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMale, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/male.9078c6ee.svg";
export { ForwardRef as ReactComponent };